<template>
    <div>
        <div class="module-body">
            <form role="form" method="POST" @submit.prevent="doSubmit">
                <h5 class="form__subtitle">{{ $t('words.login_info') }}</h5>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="email">{{ $t('words.email') }}</label>
                    <div class="col-md-9">
                        <input type="email" class="form-control" id="email" :value="getLoginAccount.email" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="name">{{ $t('words.name') }}</label>
                    <div class="col-md-9">
                        <input type="email" class="form-control" id="name" :value="getLoginAccount.name" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="role">{{ $t('words.role') }}</label>
                    <div class="col-md-9">
                        <input type="email" class="form-control" id="role" :value="getLoginAccountRole" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="timezone">{{ $t('words.timezone') }}</label>
                    <div class="col-md-9">
                        <select id="timezone_selectize" v-model="timezone">
                            <!--<optgroup :label="group_index" v-for="(items, group_index) in timezones" :key="group_index">-->
                            <!--<option v-for="(item, index) in items" :value="index" v-html="item" :key="index"></option>-->
                            <!--</optgroup>-->
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="timezone">{{ $t('words.language') }}</label>
                    <div class="col-md-9">
                        <select id="language" class="form-control" v-model="language">
                            <option v-for="(item, index) in languages" :value="item.code" v-html="item.name" :key="index"></option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
        <div class="module-footer">
            <button type="submit" class="btn btn-lg btn-primary" v-if="haveSubmitRight" @click.prevent="doSubmit">
                {{ $t('words.save') }}
            </button>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
    },
    data() {
        return {
            login_account: {

            },
            timezone: null,
            language: null,
            timezones: {},
            languages: [],
            meta: {
                errors: {},
            },
        };
    },
    mounted() {
        if (this.loadedLoginAccount) {
            this.initialize();
        }
    },
    methods: {
        loadTimeZoneSelectize() {
            const timezoneOptions = [];
            const timezoneOptGroups = [];

            _.forEach(this.timezones, (groupValue, groupKey) => {
                timezoneOptGroups.push({ value: groupKey, label: groupKey });
                _.forEach(groupValue, (value, key) => {
                    timezoneOptions.push({ class: groupKey, value: key, name: value });
                });
            });

            const self = this;
            const selectizeObj = $('#timezone_selectize').selectize({
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.timezone = value;
                },
                optgroups: timezoneOptGroups,
                optgroupField: 'class',
                options: timezoneOptions,
                labelField: 'name',
                searchField: ['name'],
                render: {
                    item(item, escape) {
                        return `<div>${item.name}</div>`;
                    },
                    option(item, escape) {
                        return `<div style="padding: 4px 12px">${item.name}</div>`;
                    },
                },
            });

            selectizeObj[0].selectize.setValue(this.timezone, true);
        },
        initialize() {
            this.loadTimezones();
            this.loadLanguages();
            this.language = this.getLoginAccount.language_code;
            this.timezone = this.getLoginAccount.timezone;
        },
        loadTimezones() {
            axios.get('/cms/account/timezones').then((response) => {
                this.timezones = response.data;
            });
        },
        loadLanguages() {
            axios.get('/cms/account/languages').then((response) => {
                this.languages = response.data.data;
            });
        },
        doSubmit() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }

            const confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            if (confirm(confirmMessage)) {
                axios.put('/cms/account', {
                    timezone: this.timezone,
                    language_code: this.language,
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.update'));
                    document.cookie = `locale=${this.language}; path=/`;
                    location.reload();
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.update'));
                });
            }
        },
    },
    computed: {
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
    },
    watch: {
        loadedLoginAccount(newValue) {
            this.initialize();
        },
        timezones(newValue, oldValue) {
            if (typeof newValue !== 'undefined' && Object.getOwnPropertyNames(newValue).length > 0) {
                this.loadTimeZoneSelectize();
            }
        },
    },
};
</script>

<style scoped>

</style>
